export function getPathWithForwardSlash(path: string) {
  return path?.startsWith("/") ? path : `/${path}`
}
